/*# sourceMappingURL=/ba/public/template-six.component.css.map */
